import { normalizeReportViewModel } from "../ReportContent/normalizeReportViewModel";

export const buildExportReportModel = ({
  aiAnalysis,
  getAdvancedReportInfo,
  isRTL,
  reportApiResponse,
  reportData,
  selectedReport,
}) => {
  const language = isRTL ? "ar" : "en";
  const normalized = normalizeReportViewModel({ aiAnalysis, reportApiResponse });
  const reportInfo = getAdvancedReportInfo(selectedReport) || {};

  return {
    reportKey: selectedReport,
    reportName: reportInfo.name || selectedReport,
    generatedAt: new Date().toISOString(),
    language,
    direction: isRTL ? "rtl" : "ltr",
    aiServiceFailure: Boolean(reportApiResponse?.aiServiceFailure || normalized.hasError),
    userFacingAiError: reportApiResponse?.userFacingAiError || normalized.errorMessage || "",
    reportTitle: normalized.reportTitle || reportInfo.name || selectedReport,
    reportSubtitle: normalized.reportSubtitle || "",
    reportDescription: normalized.reportDescription || "",
    reportMeta: normalized.reportMeta || [],
    basicReportData: normalized.basicReportData || [],
    numericalResults: normalized.numericalResults || null,
    analysis: normalized.analysis || [],
    recommendationsAndAlerts: normalized.recommendationsAndAlerts || [],
    hasAnyContent: Boolean(
      normalized.reportMeta?.length ||
        normalized.basicReportData?.length ||
        normalized.numericalResults?.rows?.length ||
        normalized.analysis?.length ||
        normalized.recommendationsAndAlerts?.length
    ),
    rawReportData: reportData || null,
  };
};
